import React from "react";
import { HubContextMenu } from "../../components";
import {
  useDeleteWorkOrder,
  usePutAdminCloseWorkOrder,
  useScheduleContext,
} from "../../hooks";
import { Stack, Typography } from "@mui/material";

const MENU_ITEMS = [
  {
    id: "edit",
    label: "Edit Work Order",
    icon: "Edit",
  },
  {
    id: "close",
    label: "Close Work Order",
    icon: "Archive",
  },
  // {
  //   id: "print",
  //   label: "Print Work Order",
  //   icon: "FileText",
  // },
  {
    id: "delete",
    label: "Delete Work Order",
    icon: "Trash2",
    color: "redError",
  },
];

const ScheduleTableContextMenu = ({ id, workOrder }) => {
  const { setOpen = () => {} } = useScheduleContext();
  const { mutate: close } = usePutAdminCloseWorkOrder();
  const { mutate: deleteWorkOrder } = useDeleteWorkOrder();

  const onSelect = (item) => {
    switch (item?.id) {
      case "edit":
        setOpen(workOrder);
        break;
      case "close":
        close({ id: workOrder });
        break;
      case "print":
        break;
      case "delete":
        deleteWorkOrder(workOrder);
        break;
      default:
        break;
    }
  };

  return (
    <HubContextMenu
      id={`schedule-gantt-details-${id}`}
      loading={false}
      menuItems={MENU_ITEMS}
      onSelect={onSelect}
      IconButtonProps={{
        className: "GanttBox-ContextMenu",
        sx: { width: "100%", height: "100%" },
      }}
      HubIconProps={{ size: 14 }}
      displayOnSelect
    >
      <Stack
        direction="row"
        gap="5px"
        padding="3px 12px 10px 12px"
        mb="7px"
        borderBottom="1px solid"
        borderColor="hubColors.greyLight"
      >
        <Typography variant="boldCaptionL">Actions for {workOrder}</Typography>
      </Stack>
    </HubContextMenu>
  );
};

export default ScheduleTableContextMenu;
